import type { ApiKey } from '@column/api';

export type APIKey = ApiKey;

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message?: unknown }).message ?? 'Something went wrong');
  }
  return 'Something went wrong';
};
